import React from "react";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Input, message, Modal } from 'antd'
import { PicturesWall } from '../PicturesWall/PicturesWall';
import * as Yup from "yup";
import styles from './FeedbackForm.module.css';
import Api from "../../services/APIService";

const { TextArea } = Input;

const SignupSchema = Yup.object().shape({
	feedbackText: Yup.string()
			.required('Please add message'),
	email: Yup.string()
			.email("Invalid email")
});

const showMessage = ( typeofMessage, content ) => {
	message[typeofMessage](content);
};


export class FeedbackForm extends React.PureComponent {
	constructor( props ) {
		super(props);
		this.state = {
			fileList: [],
			confirmLoading: false
		}
	}

	onSubmit = ( values, { resetForm } ) => {
		const { fileList } = this.state;
		this.setState({ confirmLoading: true })
		Api.sendFeedback(values, fileList).then(() => {
			showMessage('success', 'Thanks, we appreciate your feedback!');
			this.resetForm(resetForm);
		}).catch(() => this.setState({ confirmLoading: false }))
	}

	resetForm( resetFormCb ) {
		const { onClose } = this.props
		this.setState({ confirmLoading: false, fileList: [] });
		onClose();
		resetFormCb();
	}


	onFileListChange = ( fileList ) => this.setState({ fileList });


	render() {
		const { visible } = this.props
		const { fileList, confirmLoading } = this.state;
		return (
				<Formik
						initialValues={ { email: '', feedbackText: '' } }
						validationSchema={ SignupSchema }
						onSubmit={ this.onSubmit }
				>
					{ ( {
							values,
							handleChange,
							handleBlur,
							resetForm,
							handleSubmit
						} ) => {
						return <Modal
								title='Help us to become better!'
								visible={ visible }
								confirmLoading={ confirmLoading }
								okButtonProps={{htmlType: 'submit'}}
								onOk={ handleSubmit }
								onCancel={ () => this.resetForm(resetForm) }
						>
							<form>
								<label htmlFor="my_email">Email</label>
								<div className={ styles.email_container }>
									<Input onChange={ handleChange }
										   value={ values.email }
										   id='my_email'
										   name='email'
										   className={ styles.email_container__input }
										   onBlur={ handleBlur }
										   placeholder="Email"
									/>
									<ErrorMessage name='email'>{ msg => <p
											className={ styles.error_style }>{ msg }</p> }</ErrorMessage>
								</div>
								<label htmlFor="message">What you would like to improve?<span
										className={ styles.mark_required }>*</span> </label>
								<TextArea
										value={ values.feedbackText }
										name='feedbackText'
										id='message'
										onBlur={ handleBlur }
										onChange={ handleChange }/>
								<ErrorMessage name='feedbackText'>{ msg => <p
										className={ styles.error_style }>{ msg }</p> }</ErrorMessage>
								<PicturesWall fileList={ fileList } onFileChange={ this.onFileListChange }/>
							</form>

						</Modal>
					} }
				</Formik>
		)
	}
}
